<template>
    <div class="chat-page">
        <titleBar :title="title" right-icon="person" @iconClick="barClickHandle"></titleBar>
        <div class="chat-container">
            <div class="chat-message-list" ref="chatMessageList">
               <!-- <template v-if="true">
                    <span class="chat-message_time">23:15</span>
                </template>-->
                <messageItem v-for="message in currentMessageList"
                    style="margin-top: 20px"
                    :key="message.ID"
                    :message="message"></messageItem>
            </div>
        </div>
        <chatFooter></chatFooter>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import titleBar from '../../components/titleBar';
import chatFooter from '../../components/chatFooter';
import messageItem from '../../components/messageItem';
import api from '@/service/modules/instantMessaging';
import { eventBus } from '@/main';
export default {
    name: "chatInterface",
    components: {
        titleBar,
	    chatFooter,
	    messageItem
    },
    data() {
        return {
	        preScrollHeight: 0,
	        isShowScrollButtomTips: false,
        };
    },
    computed: {
	    ...mapState('instantMessaging', ['currentMemberList', 'currentMessageList', 'isReady', 'currentConversation', 'currentUserProfile']),
        ...mapGetters('instantMessaging', ['toAccount', 'isCustom']),
	    title() {
	        if (!this.currentConversation || !this.currentConversation.groupProfile) {
	            return '退货服务窗';
	        }
            if (this.currentConversation.conversationID.includes('GROUPTIO')) {
    	        return `${this.currentConversation.groupProfile.name}`
            } else {
                return `「${this.currentConversation.groupProfile.name}」退货服务窗`
            }
	    }
    },
    watch: {
    },
	mounted() {
	    this.getConversation(100);
		this.$bus.$on('scroll-bottom', this.scrollFooter);
        console.log('currentMessageList---', this.currentMessageList)

        console.log('当前会话信息', this.currentConversation)
	},
	beforeDestroy() {
		// this.tim.logout();
		api.checkChat({
			groupId: this.toAccount,
			fromUserId: this.currentUserProfile.userID
		})
	},
    beforeRouteLeave(to, from, next) {
        // console.log('to', to)
        // console.log('from', from)
        if (to.path === '/refund/refundDetail') {
            this.tim.logout();
        }
        next()
    },
    methods: {
        ...mapActions('instantMessaging', ['checkoutConversation']),
        ...mapMutations('instantMessaging', ['updateCurrentUserRole']),
	    barClickHandle() {
	        console.log('点击图标');
	    },
	    scrollFooter(){
		    let $el = this.$refs['chatMessageList'];
		    if($el){
			    this.$nextTick(()=>{
				    $el.scrollTop = $el.scrollHeight
			    })
		    }
		    this.$nextTick(() => {
			    let messageListNode = this.$refs['chatMessageList'];
			    if (!messageListNode) {
				    return
			    }
			    messageListNode.scrollTop = messageListNode.scrollHeight;
			    this.preScrollHeight = messageListNode.scrollHeight;
			    this.isShowScrollButtomTips = false
		    })
	    },
	    getConversation(time) {
	        if (!this.isReady) {
	            return setTimeout(() => {
	                this.getConversation(time);
	            }, time)
	        }
		    let query = this.$route.query;
		    console.log('66666666666666+++++++', query);
		    this.checkoutConversation(`GROUP${query.refundId}`).then(() => {
			    this.$nextTick(() => {
				    this.scrollFooter('chatMessageList');
			    });
		    });
	    }
    }
}
</script>

<style scoped lang="less">
.chat-page {
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
}
.chat-container {
    width: 100%;
    flex: 1;
    overflow-y: hidden;

    .chat-message-list {
        width: 100%;
        height: 100%;
        padding: 12px;
        padding-bottom: 32px;
        overflow-y: auto;
        box-sizing: border-box;

        .chat-message_time {
            display: block;
            margin: 16px auto 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #71747A;
            text-align: center;
            letter-spacing: 0;
        }
    }
}
</style>
